<template>
  <div class="main">
    <div class="top">
      <van-sticky>
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item v-if="checkLineListData.length > 0" :title="checkLineListData[value3].linename" ref="checklineSelect">
            <van-cell :class="index == value3 ? 'van-dropdown-item__option--active' : ''" v-for="(item, index) in checkLineListData" center
                      :key="`checkLineListData-${index}`" :name="item.lineid"
                      :title="item.linename" :label="item.memo" @click="checkLineList(index)">
              <template #right-icon v-if="index == value3">
                <van-icon name="success"/>
              </template>
            </van-cell>
          </van-dropdown-item>
<!--          <van-dropdown-item v-model="value2" :options="option2" @change="bookedPatientList"/>-->
          <van-dropdown-item v-model="value1" :options="option1" @change="selectList"/>
        </van-dropdown-menu>
      </van-sticky>
    </div>
    <div class="package" v-if="allpackageData.length > 0">
      <div  class="package-item" v-for="item in allpackageData" v-bind:key="item.packageId"
           @click="toDetail(item.packageId,item.checkTotal,item.checkLine)">
        <div style="width: 20%;height: 100%;padding: 10px;" >
          <img :src='item | picFilter' style="width: 70px;height: 70px;border-radius: 1rem;">
        </div>
        <div  style="width: 80%;height: 100%;display: flex;flex-flow: column;justify-content: space-around;padding-right: 10px">
          <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;margin-top: 8px;margin-bottom: 10px">
            {{ item.packageName }}
          </span>
          <span style="font-size: 2.2rem;color: #898989;">
            <span v-if="hospitalnameShow" style="padding-right: 1em;">{{ hospitalname }}</span>
            性别：
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '1'">男性</span>
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '2'">女性</span>
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '0'">不限</span>
            婚姻：

            <span style="margin-right: 2.2rem;" v-if="item.marriage == '1'">已婚</span>
            <span style="margin-right: 2.2rem;" v-if="item.marriage == '2'">未婚</span>
            <span style="margin-right: 2.2rem;" v-if="item.marriage == '0'">不限</span>
          </span>
          <div style="width: 100%;display: flex;justify-content: flex-end;align-items: center;">
            <span v-if="showMoney && showOriginalMoney && !isFestival && !isContain(item)" style="font-size:2.2rem;color: #F56C6C;margin-right: 1em;">优惠价<em style="font-size: 1.8rem">￥</em>{{ item.actualPrice.toFixed(2) }}</span>
            <span v-if="showMoney && !showOriginalMoney && !isContain(item)" style="font-size:2.2rem;color: #F56C6C;margin-right: 1em;"><em style="font-size: 1.8rem">￥</em>{{ item.actualPrice.toFixed(2) }}</span>
            <span v-if="showMoney && !showOriginalMoney && !isFestival && isContain(item)" style="font-size:2.2rem;color: #F56C6C;margin-right: 1em;"><em style="font-size: 1.8rem">￥</em>{{ item.actualPrice.toFixed(2) }}</span>
            <span v-if="showMoney && showOriginalMoney && !isFestival && !isContain(item)" style="font-size: 2.2rem;color: #898989;margin-right: 1em;">原价<em style="font-size: 1.8rem">￥</em>{{ item.price.toFixed(2) }}</span>

            <span v-if="showMoney && isFestival && isContain(item)"
                  style="font-size:1.8rem;color: #F56C6C;margin-right: 1em;color: #ff6c6c;padding: 0 5px;border-radius: 10px;">{{ festivalName }}<em style="font-size: 1.8rem">￥</em>{{ item.actualPrice.toFixed(2) }}</span>
            <span v-if="showMoney && isFestival && isContain(item)" style="font-size: 2.2rem;color: #898989;margin-right: 1em;"><span style="text-decoration: line-through"><em style="font-size: 1.8rem">￥</em>{{ item.price }}</span></span>
<!--            <span style="font-size: 2.3rem;color: #898989;margin-right: 2rem;">{{ item.checkTotal }} 人已选</span>-->
            <van-button round hairline size="mini" type="info" style="font-size: 1.8rem;padding-left: 1.5rem" @click.stop="showDetail(item.packageId)">查看项目<van-icon name="arrow" /></van-button>

          </div>
        </div>
        <div>
        </div>
      </div>
      <div style="width: 100%;padding-bottom: 4rem;">
        <van-divider>没有更多了</van-divider>
      </div>
    </div>
    <div v-if="allpackageData.length == 0">
      <van-empty image="search" description="没有查询到套餐"/>
    </div>
    <div v-if="qsBanner" class="footer" @click="toQuestion">
      <div style="width: 65%;display: flex;flex-flow: column;">
        <div style="width: 100%;display: flex;justify-content: center">
          <span style="font-size: 2.5rem;">没找到合适的套餐？</span>
        </div>
        <div style="width: 100%;display: flex;justify-content: center;margin-top: 0.5rem;">
         <span style="font-size: 2.6rem;">
           <span>试一试<span style="font-size: 3.2rem;font-weight: 700;"> 个性化体检 </span>吧！</span>
         </span>
        </div>
      </div>
      <div style="width: 35%;height:100%;">
        <img src="@/assets/images/medical.png" style="width: 80%;height: 100%;">
      </div>
    </div>
    <van-popup close-icon="close" closeable v-model="showPackageDetail"
               round position="bottom" :style="{ height: '90%' }">
      <div style="width: 100%;height: 7%"></div>
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <span style="font-size: 3rem;margin-left: 2rem;">{{ packageDetail.packageName }}</span>
        <span style="font-size: 2.3rem;color: #898989;padding: 1em;color: #576b95;">{{ packageDetail.description }}</span>
      </div>
      <div style="width: 100%;height: 85%;display: flex;justify-content: center;">
        <div style="width: 96%;height: 100%;overflow-y: scroll;">
          <div v-for="(item,index) in packageDetail.basicGroupInfos" v-bind:key="item.groupId">
            <van-cell center style="border-bottom: 1px solid #f5f0f0;" :title-class="item.isDelete == '2'?'text-decoration':''" :title=" (index + 1) + '、' + item.groupName"
                      :label="item.clinicalSignIficance | valueFilter" />
          </div>
          <van-empty v-if="packageDetail.basicGroupInfos == null || packageDetail.basicGroupInfos.length <= 0" description="未设置项目" />
        </div>
      </div>
    </van-popup>

    <!-- 套餐选择后提示框-->
    <van-dialog v-model="tipsShow" title="提示" v-if="portfolioTips"  :before-close="tipsConfirm" confirm-button-text="继续">
      <html-panel :url="getPageUrl"></html-panel>
    </van-dialog>
  </div>
</template>

<script>
import {
  getDefualtPackage,
  getPackageDetialByPackageId,
  getCheckLineList,
  getQueueregistByPatientid
} from '@/api/module/index'
import {Toast} from "vant";
import HtmlPanel from "@/components/HtmlPanel.vue";

export default {
  name: "index",
  components: {HtmlPanel},
  data() {
    return {
      value1: 0,
      value2: 1,
      value3: 0,
      option1: [
        {text: '全部套餐', value: 0},
        {text: '男性专区', value: 1},
        {text: '女性专区', value: 2},
        {text: '已婚专区', value: 3},
        {text: '未婚专区', value: 4},
        {text: '价格 500 以下', value: 5},
        {text: '价格 500-1000', value: 6},
        {text: '价格 1000-2000', value: 7},
        {text: '价格 2000-3000', value: 8},
        {text: '价格 3000-5000', value: 9},
        {text: '价格 5000以上', value: 10}
      ],
      option2: [
        {text: '销量排序', value: 1},
        {text: '价格低到高', value: 2},
        {text: '价格高到低', value: 3}
      ],
      allpackageData: [],
      hospitalname: window.g.VUE_APP_HOSPITALNAME,
      hospitalnameShow:window.g.VUE_APP_HOSPITALNAME_SHOW,//套餐列表是都显示医院名称
      showMoney:window.g.VUE_APP_SHOW_MONEY,//是否显示价格
      showOriginalMoney:window.g.VUE_APP_SHOW_ORIGINAL_MONEY,//是否显示原价
      qsBanner:window.g.VUE_APP_QS_BANNER,
      queryParam: {},//查询参数
      showPackageDetail:false,
      packageDetail:{},
      tipsShow:false,//是否显示提示框
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/packageTips.html',
      portfolioTips:window.g.VUE_APP_PORTFOLIO_TIPS, //是否显示提示
      packageId:'',
      checkTotal:'',
      checkLine:'',
      sexFilter:window.g.VUE_APP_ORDER_SEX_FILTER, // 按性别过滤套餐
      checkLineListData:[],//检线列表数据
      VUE_APP_FESTIVAL:window.g.VUE_APP_FESTIVAL,
      isFestival:false,//是否是节日
      festivalName:'活动价',//节日名称
    };
  },
  created() {
    sessionStorage.removeItem("allpackage")
    this.setisFestival()
    this.getChecklineData()
    this.getList()

    // 获取链接的推荐码；
    if(this.$route.query.recommendCode){
      localStorage.setItem("referralcode",this.$route.query.recommendCode)
      console.log("referralcode",this.$route.query.recommendCode);
    }
  },
  filters: {
    valueFilter: function (value) {
      if (value == null || value == '') {
        return ''
      } else {
        return value
      }
    },
    filterMoney(value,showMoney){
      if(showMoney){
        return '（￥' + value + '）'
      }
      else{
        return ""
      }
    },
  },
  methods: {
    //判断套餐是否匹配活动
    isContain(packageObj){
      let isContain = false
      let festivals = []
      if(this.VUE_APP_FESTIVAL && this.VUE_APP_FESTIVAL.length > 0){
        this.VUE_APP_FESTIVAL.forEach(item=>{
          if(item.packagetext && item.packagetext!="" && item.open == true && new Date(item.startdate) <= new Date()){
            let arr = item.packagetext.split(",")
            festivals.push({
              text:arr,
              sex:item.sex,
              discount:item.discount
            })
          }
        })
        if(festivals && festivals.length > 0){
          let isMatch = false;
          festivals.forEach(f=>{
            if(isMatch){
              return false
            }
            //定义变量是否匹配到
            let texts = f.text
            let sex = f.sex
            if(texts && texts.length > 0){
              texts.forEach(textItem=>{
                if(packageObj.packageName.includes(textItem)){
                  isMatch = true
                  isContain = true
                  return false
                }
              })
            }
            if(isContain){
              console.log(packageObj.sexId + " " + sex)
              //判断性别是否匹配
              if(packageObj.sexId == sex){
                isMatch = true
                isContain = true
              }
              else{
                isContain = false
              }
            }
          })
          return isContain
        }
        else{
          return false
        }
      }
      else{
        return false
      }
    },
    setisFestival(){
      // 判断是否是设置的节日
      let festival = this.VUE_APP_FESTIVAL
      if(festival && festival.length > 0){
        for(let i=0;i<festival.length;i++){
          if(new Date(festival[i].startdate) <= new Date() && new Date(festival[i].enddate) >= new Date() && festival[i].open == true){
            this.isFestival = true
            this.festivalName = festival[i].name
            break
          }
        }
      }
    },
    toDetail(packageId,checkTotal,checkLine) {
      this.tipsShow = true;
      this.packageId = packageId;
      this.checkTotal=checkTotal;
      this.checkLine = checkLine;
      if (!this.portfolioTips){
        this.toPackageDetail()
      }
    },
    // tips 确认按钮
    tipsConfirm(action, done) {
      if (action === 'confirm') {
        done();
        this.toPackageDetail()
      } else {
        done();
      }
    },
    // 跳转
    toPackageDetail() {
      this.$router.push({name: 'packageDetail', query: {
        packageId: this.packageId,
          checkTotal:this.checkTotal,
          checkLine:this.checkLine
      }})
    },
    // 获取检线列表数据
    getChecklineData() {
      getCheckLineList().then(res => {
        if (res.code == 200) {
          this.$nextTick(() => {
            this.checkLineListData = res.data.filter(item => {
              return item.lineid != 2
            })
          })
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    //默认查询所有体检套餐
    getList() {
      let all;
      if (sessionStorage.getItem("allpackage") != undefined && sessionStorage.getItem("allpackage") != null) {
        all = JSON.parse(sessionStorage.getItem("allpackage"))
      }
      if (all != null && all != undefined) {
        this.allpackageData = all
        this.filtration(this.allpackageData)
      } else {
        let param = {
          checkLine:""
        }
        getDefualtPackage(param).then(res => {
          if (res.code == 200) {
            this.allpackageData = res.data
            this.setFesetivalPrice()
            //筛选
            this.filtration(this.allpackageData)
            sessionStorage.setItem("allpackage", JSON.stringify(this.allpackageData))
          } else {
            Toast.fail('服务器出错！');
          }
        })
      }
    },
    setFesetivalPrice(){
      //节日价格设置
      let festivals = []
      if(this.VUE_APP_FESTIVAL && this.VUE_APP_FESTIVAL.length > 0){
        this.VUE_APP_FESTIVAL.forEach(item=>{
          if(item.packagetext && item.packagetext!=""){
            let arr = item.packagetext.split(",")
            festivals.push({
              text:arr,
              discount:item.discount,
              sex:item.sex
            })
          }
        })
      }
      if(festivals && festivals.length > 0){
        this.allpackageData.forEach(item=>{
          let isMatch = false;
          for(let i=0;i<festivals.length;i++){
            if(isMatch){
              break
            }
            let texts = festivals[i].text
            if(texts && texts.length > 0){
              for(let j=0;j<texts.length;j++){
                if(item.packageName.includes(texts[j]) && item.sexId == festivals[i].sex){
                  let tempPrice = item.actualPrice;
                  item.price = tempPrice
                  item.actualPrice = tempPrice * festivals[i].discount
                  isMatch = true
                  break
                }
              }
            }
          }
        })
      }
    },
    // 过滤套餐
    filtration(item){
      if(this.sexFilter){
        this.allpackageData=item.filter(item=>{
          const user = JSON.parse(localStorage.getItem("loginuser"));
          if(user!=null){
            if(item.sexId==user.sexid || item.sexId=='0'){
                return item
            }
          }else{
              return item
          }
        })
        // this.allpackageData.sort((a, b) => {
        //   // 排序逻辑
        //   return a.dispOrder < b.dispOrder
        // });
      }
    },
    //套餐检线筛选
    checkLineList(index) {
      this.value3 = index
      let checkLineId = this.checkLineListData[index].lineid
      this.$refs.checklineSelect.toggle();
      let param = {}
      switch (this.value1) {
        case 0: {
          param = {}
          break;
        }
        case 1: {
          param = {
            sexId: '1'
          }
          break;
        }
        case 2: {
          param = {
            sexId: '2'
          }
          break;
        }
        case 3: {
          param = {
            marriage: '1'
          }
          break;
        }
        case 4: {
          param = {
            marriage: '2'
          }
          break;
        }
        case 5: {
          param = {
            beginActualPrice: 0,
            endActualPrice: 500
          }
          break;
        }
        case 6: {
          param = {
            beginActualPrice: 500,
            endActualPrice: 1000
          }
          break;
        }
        case 7: {
          param = {
            beginActualPrice: 1000,
            endActualPrice: 2000
          }
          break;
        }
        case 8: {
          param = {
            beginActualPrice: 2000,
            endActualPrice: 3000
          }
          break;
        }
        case 9: {
          param = {
            beginActualPrice: 3000,
            endActualPrice: 5000
          }
          break;
        }
        case 10: {
          param = {
            beginActualPrice: 5000,
            endActualPrice: 0
          }
          break;
        }
      }
      switch (checkLineId) {
        case "1": {
          param.checkLine='1'
          break;
        }
        case "2": {
          param.checkLine='2'
          break;
        }
        case "3": {
          param.checkLine='3'
          break;
        }
        case "4": {
          param.checkLine='4'
          break;
        }
        default:{
          param.checkLine=''
        }
      }
      this.queryParam = param
      getDefualtPackage(this.queryParam).then(res => {
        if (res.code == 200) {
          this.allpackageData = res.data
          this.setFesetivalPrice()
          this.originalData = res.data
          //查完再排序
          this.bookedPatientList()
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    //套餐销量排序
    bookedPatientList() {
      switch (this.value2) {
        case 1: {
          //销量排序 降序
          this.allpackageData = this.allpackageData.sort((a, b) => {
            return b.checkTotal - a.checkTotal
          })
          break;
        }
        case 2: {
          //价格排序 升序
          this.allpackageData = this.allpackageData.sort((a, b) => {
            return parseFloat(a.actualPrice) - parseFloat(b.actualPrice)
          })
          break;
        }
        case 3: {
          //价格排序 降序
          this.allpackageData = this.allpackageData.sort((a, b) => {
            return parseFloat(b.actualPrice) - parseFloat(a.actualPrice)
          })
          break;
        }
      }
    },
    //套餐过滤
    selectList() {
      let param = {}
      switch (this.value1) {
        case 0: {
          param = {}
          break;
        }
        case 1: {
          param = {
            sexId: '1'
          }
          break;
        }
        case 2: {
          param = {
            sexId: '2'
          }
          break;
        }
        case 3: {
          param = {
            marriage: '1'
          }
          break;
        }
        case 4: {
          param = {
            marriage: '2'
          }
          break;
        }
        case 5: {
          param = {
            beginActualPrice: 0,
            endActualPrice: 500
          }
          break;
        }
        case 6: {
          param = {
            beginActualPrice: 500,
            endActualPrice: 1000
          }
          break;
        }
        case 7: {
          param = {
            beginActualPrice: 1000,
            endActualPrice: 2000
          }
          break;
        }
        case 8: {
          param = {
            beginActualPrice: 2000,
            endActualPrice: 3000
          }
          break;
        }
        case 9: {
          param = {
            beginActualPrice: 3000,
            endActualPrice: 5000
          }
          break;
        }
        case 10: {
          param = {
            beginActualPrice: 5000,
            endActualPrice: 0
          }
          break;
        }
      }
      param.checkLine=this.checkLineListData[this.value3].lineid=="0"?'':this.checkLineListData[this.value3].lineid
      this.queryParam = param
      getDefualtPackage(this.queryParam).then(res => {
        if (res.code == 200) {
          this.allpackageData = res.data
          this.setFesetivalPrice()
          this.originalData = res.data
          //查完再排序
          // this.bookedPatientList()
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    toQuestion() {
      this.$router.push({name: 'questionnaire'})
    },
    //查看套餐明细项目
    showDetail(packageId) {
      this.showPackageDetail = true
      getPackageDetialByPackageId({packageId: packageId}).then(res => {
        if (res.code == 200) {
          this.packageDetail = res.data
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    getNow() {
      let d = new Date();
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth() + 1;
      if (mm1 < 10) {
        mm1 = '0' + mm1
      }
      let dd1 = d.getDate();
      if (dd1 < 10) {
        dd1 = '0' + dd1
      }
      return yy1 + '-' + mm1 + '-' + dd1
    },
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #F5F5F5;
}

.package {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: 10rem;
  margin-top: 1.5rem;
}

.package-item {
  width: 96%;
  min-height: 13rem;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-flow: row;
  justify-content: center;
  box-shadow: 0 0 1.5rem #f5f5f5;
}


.footer {
  width: 100%;
  height: 12rem;
  background-image: linear-gradient(to bottom right,#10E3E9, #5091F9,#10E3E9);
  color: #fff;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}
.van-dropdown-item__option--active{
  color: rgb(25, 137, 250);
}
</style>
